import AccountBoxRoundedIcon from "@mui/icons-material/AccountBoxRounded";
import { IconButton } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Container from "@mui/material/Container";
import { Link, useNavigate } from "@tanstack/react-router";
import InfoBookIcon from "../../../components/icons/infoBookIcon";
import theme from "../../../app/theme";
import LanguageSwitcher from "../../../components/LanguageSwitcher";

export default function Header(): React.JSX.Element {
  const navigate = useNavigate();

  const handleOpenManual = () => {
    const url =
      window.constants?.urlManual ||
      "https://manualsosdocs.gitbook.io/smartdocs-manual/portal-externo-smartdocs/portal-externo";
    window.open(url, "_blank");
  };

  return (
    <AppBar
      position="static"
      sx={{
        backgroundColor: "background.default",
        boxShadow: 1,
      }}
    >
      <Container
        id="container-app-bar"
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          overflow: "hidden",
          height: "57px",
        }}
      >
        <Link
          style={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            marginTop: "6px",
            marginBottom: "6px",
            flexDirection: "row",
            justifyContent: "center",
            textDecoration: "none",
            gap: 1,
            overflow: "hidden",
          }}
          to="/"
          search={{ search: { updatePage: 1 } }}
        >
          <img
            alt="logo"
            src="/assets/logo2.png"
            style={{
              width: "100%",
              height: "auto",
              maxWidth: "90px",
              overflow: "hidden",
            }}
            width="100%"
          />
        </Link>
        <div style={{ display: "flex", alignItems: "center" }}>
          <LanguageSwitcher />
          <IconButton
            color="primary"
            onClick={handleOpenManual}
            sx={{ height: "fit-content" }}
          >
            <InfoBookIcon color={theme.palette.primary.main} />
          </IconButton>
          <IconButton
            color="inherit"
            onClick={() => {
              void navigate({ to: "/my-account" });
            }}
            sx={{ height: "fit-content" }}
          >
            <AccountBoxRoundedIcon color="primary" width="80px" />
          </IconButton>
        </div>
      </Container>
    </AppBar>
  );
}
